import { useState } from 'react';
import { Button, Group, IconPlusCircle, Wrapper } from '@screentone/core';
import { UseQueryResult } from '@tanstack/react-query';

import { ResponsiveLoader } from 'components';
import { ArtifactType, GetArtifactSettingsQuery, useGetArtifactSettingsQuery } from 'data/generated/graphql';
import { useConvertedProperty } from 'hooks';
import { LayoutSearchBar } from './components/layout-search-bar/LayoutSearchBar';
import { LayoutsList } from './components/layouts-list/LayoutsList';
import { CreateLayoutModal } from './components/modals/CreateLayoutModal';

export type LayoutList = NonNullable<GetArtifactSettingsQuery['getArtifactSettings']>[number];

export const Layouts = () => {
  const currentProperty = useConvertedProperty();
  const [searchTerm, setSearchTerm] = useState('');
  const [createOpen, setCreateOpen] = useState(false);

  const { data, isLoading } = useGetArtifactSettingsQuery(
    {
      publicationKey: currentProperty!,
      artifactType: ArtifactType.Layout,
      artifactIdSearch: searchTerm || undefined
    },
    { enabled: !!currentProperty }
  ) as UseQueryResult<GetArtifactSettingsQuery>;

  const allLayouts = data?.getArtifactSettings;

  const handleSearchChange = (newSearchTerm: string) => {
    setSearchTerm(newSearchTerm);
  };

  return (
    <Wrapper>
      <Group align="end" valign="center" margin={{ top: 'md', bottom: 'sm' }}>
        <Button tertiary icon={IconPlusCircle} onClick={() => setCreateOpen(true)}>
          New layout
        </Button>
      </Group>
      <LayoutSearchBar onSearchChange={handleSearchChange} />
      {isLoading ? <ResponsiveLoader /> : <LayoutsList layouts={allLayouts ?? []} />}
      {createOpen && <CreateLayoutModal onDismiss={() => setCreateOpen(false)} />}
    </Wrapper>
  );
};
